import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=728048fc&scoped=true"
var script = {}
import style0 from "./notFound.vue?vue&type=style&index=0&id=728048fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728048fc",
  null
  
)

export default component.exports